import { createFileRoute } from '@tanstack/react-router';
import { HistoryPage } from '../../import/HistoryPage.js';

/** `/import/history` (2.B-2 stage s3): every import run, with Import again and Undo import. */
export const Route = createFileRoute('/import/history')({
  staticData: { crumb: 'Import history' },
  component: HistoryRoute,
});

function HistoryRoute(): React.JSX.Element {
  const { me } = Route.useRouteContext();
  return <HistoryPage me={me} />;
}
